import { HttpContextToken } from '@angular/common/http';

/** When true, the global ngx-spinner loader is not shown for this request. */
export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);
